import styles from './PanelSidebarFields.module.css'
import { SvgSearch } from '../../svg/SvgComponents'

function PanelSidebarFields({ children, title }) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
      </div>
      {/* <div className={styles.search__bar_content}>
        <div className={styles.search__bar}>
          <div className={styles.svg_search}>
            <SvgSearch />
          </div>
          <input
            type="email"
            className={styles.input__search}
            placeholder="Chercher un élement"
            aria-label="Email"
          ></input>
        </div>
      </div> */}
      <div className={styles.container}>{children}</div>
    </div>
  )
}

export default PanelSidebarFields
